import { Constants, ICountry, ILookup } from 'common';
import { IGeneralDetailsData } from '../../../interfaces/account-registration/general-details-data.interface';
import { IPrsData } from '../../../interfaces/account-registration/prs-data.interface';
import { AddressDto } from './address.dto';

export class PrsDto {
  isMobileOperator: boolean;
  isFixedOperator: boolean;
  organisationType: string;
  registrationNumber: string;
  exTradeName: string;
  address: AddressDto;
  code: string;
  questionOne: string;
  questionTwo: string;
  questionThree: string;

  constructor(generalDetailsData: IGeneralDetailsData, prsData: IPrsData, private orgTypes: ILookup[], private countries: ICountry[]) {
    this.isMobileOperator = false;
    this.isFixedOperator = false;
    this.organisationType = this.getPrsOrgTypeValueFromKey(generalDetailsData.orgType.value);
    this.registrationNumber = generalDetailsData.regNumber.value;
    this.exTradeName = generalDetailsData.prevTradeName.value;

    //Address
    this.address = new AddressDto(
      prsData.addressLine1.value,
      prsData.addressLine2.value,
      prsData.addressLine3.value,
      prsData.addressLine4.value,
      prsData.postCode.value,
      prsData.county.value,
      prsData.country.value
    );
    if (this.countryIsEu(prsData.country.value) && prsData.country.value.toLocaleLowerCase() !== Constants.irelandCountryString.toLocaleLowerCase()) {
      this.questionOne = prsData.q1.value;
      this.questionTwo = prsData.q2.value;
      this.questionThree = prsData.q3.value;
    }
    this.code = null;
  }

  private getPrsOrgTypeValueFromKey(key: string): string {
    var result = this.orgTypes.filter((lookup: ILookup) => {
      return lookup.key === key;
    });
    return result && result.length > 0 ? result[0].value : null;
  }

  private countryIsEu(countryName: string): boolean {
    var countryDetails = this.countries.filter((country: ICountry) => {
      return country.name.toLowerCase() === countryName.toLowerCase();
    });
    return countryDetails && countryDetails.length > 0 ? countryDetails[0].isEU : false;
  }
}
